import {MuseOn} from "./MuseOn";

export class Group extends MuseOn {
    _id: string;
    name: string;
    price: number;
    database_id: string;

    constructor (data) {
        super();

        this._id = data._id;
        this.name = data.name;
        this.price = data.price;
        this.database_id = data.database_id;
    }

    getObj(removeNull: boolean = false) {
        const result =  {
            name: this.name,
            price: this.price,
            database: this.database_id,
        };

        return removeNull
            ? this.removeNull(result)
            : result
        ;
    }
}